import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from 'bna-angular-auth-client';

@Component({
  selector: 'app-sign-in-check',
  templateUrl: './sign-in-check.component.html',
})
export class SignInCheckComponent implements OnInit {
  constructor(
    private userSessionService: UserSessionService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.userSessionService.isAuthenticated()) {
      sessionStorage.clear();
    }
    this.router.navigate(['sign-in']);
  }
}
